import React from 'react';
import { motion } from 'framer-motion';
const reformerTomos = [{
  num: 1,
  title: 'Reformer Essenziale',
  desc: 'Il primo contatto con il Reformer. Footwork, core di base e attivazione di schemi fondamentali fin dalla prima sessione.'
}, {
  num: 2,
  title: 'Reformer Intermedio',
  desc: 'Controllo eccentrico, instabilità progressiva e lavoro della catena anteriore profonda. Il livello che più allievi abbandonano senza un sistema.'
}, {
  num: 3,
  title: 'Reformer Avanzato',
  desc: "Controllo massimo del carrello, serie invertite, pliometria e sequenze senza pausa. Per l'allievo che è pronto per il livello successivo."
}, {
  num: 4,
  title: 'Reformer Casi Speciali',
  desc: 'Terza età, lesioni, riabilitativo e terapeutico. Il tomo che ti protegge legalmente e professionalmente con ogni allievo speciale.'
}, {
  num: 5,
  title: 'Reformer Fluidità & Coreografia',
  desc: 'Transizioni artistiche, musicalità e lezioni che i tuoi allievi non dimenticheranno. Il tomo che ti differenzia da qualsiasi altro istruttore.'
}, {
  num: 6,
  title: 'Reformer Esperto',
  desc: 'Programmazione avanzata, periodizzazione e il sistema completo per istruttori di livello esperto. Il tuo capolavoro nel Reformer.'
}];
const matTomos = [{
  num: 7,
  title: 'Mat Essenziale',
  desc: 'Il metodo originale di Joseph Pilates. Posture di base, respirazione e fiducia fin dalla prima lezione a terra.'
}, {
  num: 8,
  title: 'Mat Intermedio (Classico)',
  desc: "L'ordine classico completo con progressione reale. Allineamento, correzioni verbali e tecnica degli esercizi fondamentali del Mat."
}, {
  num: 9,
  title: 'Mat Avanzato',
  desc: 'Teaser, Boomerang e Control Balance. Le serie di cui i tuoi allievi più avanzati hanno bisogno e che tu puoi offrire in sicurezza.'
}, {
  num: 10,
  title: 'Mat Casi Speciali',
  desc: 'Terza età, post-parto, lesioni e riabilitativo. Sequenze terapeutiche per gli allievi che più necessitano del tuo criterio professionale.'
}, {
  num: 11,
  title: 'Mat Fluidità & Coreografia',
  desc: 'Connessione movimento-respirazione in flusso continuo. La lezione di Mat che i tuoi allievi vorranno ripetere ogni settimana.'
}, {
  num: 12,
  title: 'Mat Esperto',
  desc: "Periodizzazione annuale, identità dell'istruttore e il sistema completo per insegnare Mat al più alto livello professionale."
}];
export const Product = () => {
  return <section className="py-20 bg-white" data-id="element-181">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-182">
        {/* Product Presentation */}
        <div className="text-center mb-20" data-id="element-183">
          <div className="inline-flex items-center justify-center gap-2 px-4 py-2 rounded-full bg-brand-gold/20 text-brand-charcoal font-bold text-sm tracking-wide mb-6" data-id="element-184">
            🏆 Il Sistema N°1 per Insegnanti di Pilates
          </div>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-brand-charcoal mb-6" data-id="element-185">
            PILATES 360 — Collezione Completa
          </h2>
          <p className="text-2xl text-brand-terracotta font-serif italic mb-8" data-id="element-186">
            12 Tomi + 6 Bonus + 2 Élite — Tutto risolto, tutti i livelli.
          </p>
          <div className="flex flex-wrap justify-center gap-4 text-lg font-medium text-gray-700" data-id="element-187">
            <span className="bg-brand-sand/30 px-4 py-2 rounded-lg" data-id="element-188">
              +280 pagine
            </span>
            <span className="bg-brand-sand/30 px-4 py-2 rounded-lg" data-id="element-189">
              +150 esercizi illustrati
            </span>
            <span className="bg-brand-sand/30 px-4 py-2 rounded-lg" data-id="element-190">
              Reformer + Mat
            </span>
            <span className="bg-brand-sand/30 px-4 py-2 rounded-lg" data-id="element-191">
              Tutti i livelli
            </span>
          </div>
        </div>

        {/* Los 12 Tomos */}
        <div className="mb-16" data-id="element-192">
          <div className="text-center mb-12" data-id="element-193">
            <h3 className="text-3xl font-serif font-bold text-brand-charcoal mb-4" data-id="element-194">
              I 12 Tomi Completi
            </h3>
            <p className="text-xl text-gray-600" data-id="element-195">
              Sessioni illustrate · Per livello e obiettivo · Pronto da usare
              domani
            </p>
          </div>

          {/* Reformer Series */}
          <div className="mb-16" data-id="element-196">
            <div className="flex items-center gap-4 mb-8" data-id="element-197">
              <div className="h-px bg-brand-sand flex-1" data-id="element-198"></div>
              <h4 className="text-xl font-bold tracking-widest text-brand-terracotta uppercase" data-id="element-199">
                SERIE REFORMER
              </h4>
              <div className="h-px bg-brand-sand flex-1" data-id="element-200"></div>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-201">
              {reformerTomos.map((tomo, i) => <motion.div key={i} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} className="bg-brand-cream p-6 rounded-2xl border border-brand-sand hover:shadow-md transition-shadow" data-id="element-202">
                  <div className="text-sm font-bold text-brand-terracotta mb-2" data-id="element-203">
                    TOMO {tomo.num}
                  </div>
                  <h5 className="text-xl font-serif font-bold text-brand-charcoal mb-3" data-id="element-204">
                    {tomo.title}
                  </h5>
                  <p className="text-gray-600 leading-relaxed" data-id="element-205">{tomo.desc}</p>
                </motion.div>)}
            </div>
          </div>

          {/* Mat Series */}
          <div data-id="element-206">
            <div className="flex items-center gap-4 mb-8" data-id="element-207">
              <div className="h-px bg-brand-sand flex-1" data-id="element-208"></div>
              <h4 className="text-xl font-bold tracking-widest text-brand-terracotta uppercase" data-id="element-209">
                SERIE MAT
              </h4>
              <div className="h-px bg-brand-sand flex-1" data-id="element-210"></div>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-211">
              {matTomos.map((tomo, i) => <motion.div key={i} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} className="bg-brand-cream p-6 rounded-2xl border border-brand-sand hover:shadow-md transition-shadow" data-id="element-212">
                  <div className="text-sm font-bold text-brand-terracotta mb-2" data-id="element-213">
                    TOMO {tomo.num}
                  </div>
                  <h5 className="text-xl font-serif font-bold text-brand-charcoal mb-3" data-id="element-214">
                    {tomo.title}
                  </h5>
                  <p className="text-gray-600 leading-relaxed" data-id="element-215">{tomo.desc}</p>
                </motion.div>)}
            </div>
          </div>
        </div>

        {/* Features Footer */}
        <div className="bg-brand-charcoal text-white rounded-2xl p-8 text-center max-w-4xl mx-auto" data-id="element-216">
          <div className="grid sm:grid-cols-3 gap-6" data-id="element-217">
            <div className="font-medium" data-id="element-218">
              ✏️ Esercizi illustrati in ogni tomo
            </div>
            <div className="font-medium" data-id="element-219">⚡ Sistema "Apri e Insegna"</div>
            <div className="font-medium" data-id="element-220">📋 Schede pronte da stampare</div>
          </div>
        </div>
      </div>
    </section>;
};